import {
  Divider,
  Dropdown,
  Grid,
  MixpanelEventSource,
  MixpanelSourceProvider,
  Tour,
  type DropdownProps,
} from '@talos/kyoko';
import { TourName } from '../../tokens/tours';
import { MarketSelectorBlotter } from './blotter/MarketSelectorBlotter';
import { useMarketSelectorContext } from './MarketSelectorContext';
import { MarketSelectorPresetsList } from './presets/MarketSelectorPresetsList';
import { MARKET_SELECTOR_AGGREGATIONS_WIDTH } from './tokens';

export type MarketSelectorPanelProps = {
  dropdownProps: Omit<DropdownProps, 'children'>;
  /** Useful if you have multiple market selectors rendered at once to give them different testIDs. */
  testID?: string;
};

export const MarketSelectorPanel = ({ dropdownProps, testID }: MarketSelectorPanelProps) => {
  const { disableAggregations } = useMarketSelectorContext();

  return (
    <Dropdown portalize isParentDropdown {...dropdownProps}>
      <MixpanelSourceProvider value={MixpanelEventSource.MarketAccountSelector}>
        {/* Tour for advanced features - only show when modal is open */}
        {dropdownProps.isOpen && !disableAggregations && <Tour tour={TourName.v70MarketSelectorDefaultAggregation} />}
        {dropdownProps.isOpen && <Tour tour={TourName.v253MarketSelectorAdvancedFeatures} />}

        <Grid
          flex={1}
          gridTemplateColumns={
            disableAggregations ? 'auto' : `${MARKET_SELECTOR_AGGREGATIONS_WIDTH}px min-content auto`
          }
          data-testid={`${testID ?? 'market-selector-panel'}`}
        >
          {!disableAggregations && (
            <>
              <MarketSelectorPresetsList />
              <Divider orientation="vertical" my="0" color="backgroundDivider" />
            </>
          )}
          <MarketSelectorBlotter />
        </Grid>
      </MixpanelSourceProvider>
    </Dropdown>
  );
};
